import { render, staticRenderFns } from "./SubFAQ.vue?vue&type=template&id=e2b752f0"
import script from "./SubFAQ.vue?vue&type=script&lang=js"
export * from "./SubFAQ.vue?vue&type=script&lang=js"
import style0 from "./SubFAQ.vue?vue&type=style&index=0&id=e2b752f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports